/**
 * Central names for GTM / dataLayer marketing events and parameter keys.
 * Add new entries here instead of string literals across the app.
 *
 * GA4 User-ID: pushWorkyMarketingAnalyticsEvent merges `user_id` when
 * UserDetails.userId is present in session (see LOCAL_STORAGE_KEYS.USER_ID).
 * In GTM, create a Data Layer Variable for `user_id` and set the GA4
 * Configuration tag Field name `user_id` from that variable.
 */
const TAG_DICTIONARY = {
  EVENTS: {
    PAGE_VIEW: 'page_view',
    CTA_CLICK: 'cta_click',
    FORM_START: 'form_start',
    FORM_SUBMIT: 'form_submit',
    DEMO_BOOKED: 'demo_booked',
  },
  PARAMS: {
    PAGE_PATH: 'page_path',
    PAGE_TITLE: 'page_title',
    PAGE_LOCATION: 'page_location',
    /** Same semantic as UserDetails.userId (opaque Worky user id). */
    USER_ID: 'user_id',
    UTM_SOURCE: 'utm_source',
    UTM_MEDIUM: 'utm_medium',
    UTM_CAMPAIGN: 'utm_campaign',
    UTM_CONTENT: 'utm_content',
    UTM_TERM: 'utm_term',
    REFERRER: 'referrer',
    GCLID: 'gclid',
    FBCLID: 'fbclid',
    MSCLKID: 'msclkid',
    CTA_ID: 'cta_id',
    CTA_LABEL: 'cta_label',
    FORM_ID: 'form_id',
    FORM_NAME: 'form_name',
    CALENDLY_BOOKING_SOURCE: 'calendly_booking_source',
    CALENDLY_EVENT_TYPE_NAME: 'calendly_event_type_name',
    CALENDLY_SCHEDULED_EVENT_URI_SUFFIX: 'calendly_scheduled_event_uri_suffix',
  },
  ENTITY_IDS: {
    FORM_LANDING_FOOTER_LEAD: 'landing_page_footer_contact',
    FORM_HOMECARE_FOOTER_CALLBACK: 'homecare_footer_callback',
  },
  CALENDLY_BOOKING_SOURCES: {
    EMBED: 'calendly_embed',
    REDIRECT_RETURN: 'calendly_redirect_return',
  },
  SESSION_KEYS: {
    CALENDLY_DEMO_BOOKED_DEDUP_PREFIX: 'worky_analytics_demo_booked',
  },
} as const;

type TagDictionary = typeof TAG_DICTIONARY;

export { TAG_DICTIONARY, type TagDictionary };
